import InformationWebsiteTab from './information-website-tab'
import { IPopup } from '@/data/json/json'

export default class InformationWebsite {
  public id!: string
  public code!: string
  public title?: string
  public tabs!: InformationWebsiteTab[]

  constructor (websiteData: IPopup) {
    const { id, code, naam: title } = websiteData
    Object.assign(this, { id, code, title, tabs: [] })
  }
}
